export class LocalStorage {
    static set(name, data) {
        window.localStorage.setItem(name, JSON.stringify(data));
    }

    static get(name) {
        const item = window.localStorage.getItem(name);
        if(item) return JSON.parse(item);

        return false;
    }

    static remove(name) {
        window.localStorage.removeItem(name);
    }

    static onChange(cb) {
        window.addEventListener('storage', cb);
    }

    static removeOnChange(cb) {
        window.removeEventListener('storage', cb);
    }
}


// WEBPACK FOOTER //
// ./src/helper/localStorage.js